module.exports = __webpack_public_path__ + "img/144.6.1e268d33.png";